import React from 'react'
import { node } from 'prop-types'
import Type from '../Type'

import styles from './CaptionedMedia.module.scss'

const CaptionedMedia = ({ caption, children }) => {
  if (!caption) return children

  return (
    <figure className={styles.CaptionedMedia}>
      <div className={styles.CaptionedMediaBody}>{children}</div>
      {caption && (
        <Type
          size={['body2', 'body3']}
          className={styles.Caption}
          as="figcaption"
          useDangerouslySetInnerHTML
        >
          {caption}
        </Type>
      )}
    </figure>
  )
}

CaptionedMedia.propTypes = {
  caption: node,
  children: node.isRequired
}

export default CaptionedMedia
